import Record from '../Record'

export default class CompanyDB extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new CompanyDB({
				id: null,
				company_id: null,
				db_name: ''
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/c_order/company_db/${id}`)
			return new CompanyDB(data)
		}
	}

	static async delete (id) {
		await Anvil.REST.delete(`/c_order/company_db/${id}`)
	}

	async commit () {
		if (this._data.id == null) {
			// Insert
			const res = await Anvil.REST.post(`/c_order/company_db`, this._data)
			this._data.id = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/c_order/company_db/${this._data.id}`, this._data)
		}
	}
}
